import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import {
  type SortableTableHeaderProps,
  getColumnStyle,
} from '@modules/_shared/components/sortable-list/types';

export const SortableTableHeader = <T,>({
  columns,
  showDragHandleSpacer = false,
  dragHandleWidth = 32,
}: SortableTableHeaderProps<T>) => {
  const visibleColumns = useMemo(
    () => columns.filter(col => !col.hide),
    [columns],
  );

  return (
    <Box
      sx={theme => ({
        position: 'sticky',
        top: 0,
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: '12px',
        py: 2,
        borderBottom: `1px solid ${(theme.vars ?? theme).palette.divider}`,
        borderTop: `1px solid ${(theme.vars ?? theme).palette.divider}`,
        backgroundColor: (theme.vars ?? theme).palette.background.paper,
        fontWeight: 500,
        minHeight: 48,
      })}
    >
      {showDragHandleSpacer && (
        <Box sx={{ width: dragHandleWidth, flexShrink: 0 }} />
      )}
      {visibleColumns.map(column => {
        const headerContent = column.renderHeader
          ? column.renderHeader()
          : column.headerName ?? '';

        return (
          <Box
            key={column.field}
            sx={theme => ({
              ...getColumnStyle(column),
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              borderLeft: `1px solid ${(theme.vars ?? theme).palette.divider}`,
              pl: 1.5,
            })}
          >
            <Typography
              variant="body2"
              noWrap
              component="span"
              sx={{
                fontWeight: 500,
              }}
            >
              {headerContent}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
